// extracted by mini-css-extract-plugin
export default {"added_friend_button":"ProfilePage_added_friend_button__lQEV1"};